import { DetailsSheetVariant } from "../types";
import type { DetailsSheetViewModel, PendingCardVM } from "../types";

function getRoleFromVariant(variant: DetailsSheetVariant): "ViewOnly" | "Contributor" | "Admin" {
  if (variant.startsWith("ViewOnly_")) return "ViewOnly";
  if (variant.startsWith("Contributor_")) return "Contributor";
  if (variant.startsWith("Admin_")) return "Admin";
  throw new Error(`Unknown role in variant: ${variant}`);
}

function getPendingTypeFromVariant(variant: DetailsSheetVariant): "NoPending" | "AI" | "Manual" {
  if (variant.endsWith("_NoPending")) return "NoPending";
  if (variant.endsWith("_AI")) return "AI";
  return "Manual";
}

// Deterministic, pure mapping from DetailsSheetVariant to base UI flags; keep it declarative
export function mapVariantToBaseVM(
  variant: DetailsSheetVariant
): Pick<
  DetailsSheetViewModel,
  "pasteEnabled" | "editIconVisible" | "status" | "pendingCard" | "variant"
> {
  const role = getRoleFromVariant(variant);
  const pendingType = getPendingTypeFromVariant(variant);

  let pasteEnabled: boolean;
  let editIconVisible: boolean;
  let status: "approved" | "pending";
  let pendingCard: PendingCardVM;

  if (pendingType === "NoPending") {
    pasteEnabled = true;
    status = "approved";
    pendingCard = {
      visible: false,
      showsApproveDecline: false,
      showsDeactivateInsideCard: false,
    };
    editIconVisible = role === "Contributor" || role === "Admin";
  } else {
    pasteEnabled = false;
    status = "pending";
    pendingCard = {
    visible: true,
    showsApproveDecline: role === "Admin",
    showsDeactivateInsideCard: role === "Admin" && pendingType === "Manual",
    };
    editIconVisible = false;
  }

  return {
    pasteEnabled,
    editIconVisible,
    status,
    pendingCard,
    variant,
  };
}
